import styled from 'styled-components';
export const NotificationPreferencesCardContainer = styled.div `
  background: ${({ theme }) => `${theme.colors.white_1}99`};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  padding: 24px;
`;
export const NotificationPreferencesContainer = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 64px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
    gap: 24px;
  }
`;
export const NotificationPreferencesHeader = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 50%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    width: 100%;
  }
`;
export const NotificationPreferencesSection = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    gap: 16px;
  }
`;
export const NotificationPreferencesSwitchContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: space-between;
  }
`;
export const NotificationPreferencesSettingContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: justify;
`;
